<template>
  <div class="w-100 pa-2">
    <!-- Componente Estándar S-CRUD del Sistema SunExpert -->
    <s-crud
      ref="scrudManagementPrice"
      title="Asignación de Precios de Compra de Mango"
      :config="config"
      :filter="filter"
      :refreshTable="refreshTableToggle"
      search-input
      add
      edit
      remove
      deleteNoFunction
      addNoFunction
      @add="openDialogNewAssignment()"
      @edit="edit($event)"
      @delete="deleteAssignment($event)"
      @rowSelected="rowSelected($event)"
      height="65vh"
    >
      <!-- Filtros Superiores dentro de S-CRUD -->
      <template v-slot:filter>
        <v-container >
          <v-row dense align="center">
            <!-- Rango de Fechas -->
            <v-col cols="12" sm="6" md="2" class="s-col-form">
              <s-date
                v-model="filter.DateBegin"
                label="Fecha Inicio"
                clearable
              ></s-date>
            </v-col>
            <v-col cols="12" sm="6" md="2" class="s-col-form">
              <s-date
                v-model="filter.DateEnd"
                label="Fecha Fin"
                clearable
              ></s-date>
            </v-col>

            <!-- Combo: Tipo Precio (def 1201) -->
            <v-col cols="12" sm="6" md="2" class="s-col-form">
              <s-select-definition
                v-model="filter.TypePrice"
                :def="1201"
                label="Tipo Precio"
                clearable
              ></s-select-definition>
            </v-col>

            <!-- Combo: Tipo de moneda (def 1129) -->
            <v-col cols="12" sm="6" md="2" class="s-col-form">
              <s-select-definition
                v-model="filter.TypeCurrency"
                :def="1129"
                label="Tipo de moneda"
                clearable
              ></s-select-definition>
            </v-col>

            <!-- Combo: Cultivo (def 1173) -->
            <v-col cols="12" sm="6" md="2" class="s-col-form">
              <s-select-definition
                v-model="filter.TypeCultive"
                :def="1173"
                label="Cultivo"
                clearable
              ></s-select-definition>
            </v-col>

            <!-- Combo: Variedad -->
            <v-col cols="12" sm="6" md="2" class="s-col-form">
              <s-select-variety
                v-model="filter.VrtID"
                :cultiveID="filter.TypeCultive"
                label="Variedad"
                clearable
              ></s-select-variety>
            </v-col>

            <!-- Combo: Destino (def 1342) -->
            <v-col cols="12" sm="6" md="2" class="s-col-form">
              <s-select-definition
                v-model="filter.TypeDestiny"
                :def="1342"
                label="Destino"
                clearable
              ></s-select-definition>
            </v-col>

            
          </v-row>
        </v-container>
      </template>

      <!-- Slot Columna: Acciones -->
      <template v-slot:actions="{ row }">
        <div class="d-flex align-center justify-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon x-small color="primary" class="mr-1" @click="viewDetailMatrix(row, true)">
                <v-icon small>mdi-table-eye</v-icon>
              </v-btn>
            </template>
            <span>Ver Matriz de Precios</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon x-small color="amber darken-2" @click="duplicateAssignment(row)">
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </template>
            <span>Duplicar Configuración</span>
          </v-tooltip>
        </div>
      </template>

      <!-- Slot Columna: Tipo Precio -->
      <template v-slot:TypePriceName="{ row }">
        <v-chip
          x-small
          class="font-weight-bold rounded-pill px-2"
          :color="row.TypePrice === 2 ? '#8b5cf6' : '#2563eb'"
          dark
        >
          <v-icon x-small left>{{ row.TypePrice === 2 ? 'mdi-star-face' : 'mdi-earth' }}</v-icon>
          {{ row.TypePriceName || (row.TypePrice === 2 ? 'ESPECIAL' : 'ESTÁNDAR') }}
        </v-chip>
      </template>

      <!-- Slot Columna: Moneda -->
      <template v-slot:CurrencyName="{ row }">
        <v-chip
          x-small
          outlined
          :color="row.TypeCurrency === 2 ? '#0284c7' : '#16a34a'"
          class="font-weight-bold rounded-pill"
        >
          {{ row.CurrencyName || (row.TypeCurrency === 2 ? 'Dólares' : 'Soles') }}
        </v-chip>
      </template>

      <!-- Slot Columna: Cultivo -->
      <template v-slot:CultiveName="{ row }">
        <span class="font-weight-medium text-slate-800">{{ row.CultiveName || 'MANGO' }}</span>
      </template>

      <!-- Slot Columna: Variedad -->
      <template v-slot:VrtName="{ row }">
        <v-chip x-small color="#f1f5f9" class="font-weight-bold text-slate-800 rounded-pill">
          <v-icon x-small left color="#16a34a">mdi-leaf</v-icon>
          {{ row.VrtName || 'Kent' }}
        </v-chip>
      </template>

      <!-- Slot Columna: Rango de Fechas -->
      <template v-slot:DateRange="{ row }">
        <div class="d-flex flex-column">
          <span class="font-weight-bold text-caption text-slate-800">
            <v-icon x-small color="primary" class="mr-1">mdi-calendar-range</v-icon>
            {{ formatDateRange(row.DateBegin, row.DateEnd) }}
          </span>
          <span class="text-caption text-slate-500">({{ row.TotalDays || 7 }} días programados)</span>
        </div>
      </template>

      <!-- Slot Columna: Cantidad Calibres -->
      <template v-slot:CalibersCount="{ row }">
        <v-chip x-small outlined color="grey darken-2" class="font-weight-bold rounded-pill">
          {{ row.CalibersCount || 0 }} Calibres
        </v-chip>
      </template>

      <!-- Slot Columna: Precio Promedio -->
      <template v-slot:AvgPriceCaliber="{ row }">
        <span class="font-weight-bold text-slate-900">
          {{ row.TypeCurrency === 2 ? '$' : 'S/' }} {{ Number(row.AvgPriceCaliber || 0).toFixed(2) }}
        </span>
      </template>

      <!-- Slot Columna: Estado -->
      <template v-slot:SecStatus="{ row }">
        <v-chip
          x-small
          dark
          :color="row.SecStatus === 1 ? 'success' : 'error'"
          class="rounded-pill font-weight-medium px-2"
          style="margin: 0px;"
        >
          {{ row.SecStatus === 1 ? 'Vigente' : 'Inactivo' }}
        </v-chip>
      </template>
    </s-crud>

    <!-- ========================================================================================= -->
    <!-- MODAL PRINCIPAL: NUEVA CONFIGURACIÓN / EDICIÓN CON DISEÑO CORPORATIVO PROFESIONAL -->
    <v-dialog v-model="dialogMatrix" persistent max-width="1380px">
      <v-card v-if="dialogMatrix" class="rounded-2xl overflow-hidden dialog-modal-card">
        <!-- Toolbar Header Corporativo Elegante SunExpert -->
        <v-toolbar color="#1e3a5f" dark dense flat class="px-4 modal-toolbar">
          <div class="header-icon-circle mr-3">
            <v-icon small color="#ffffff">mdi-calendar-range</v-icon>
          </div>
          <div>
            <div class="text-subtitle-1 font-weight-bold white--text line-height-tight d-flex align-center">
              <span>
                {{ isViewOnly ? 'Visualización de Matriz de Precios' : (isEdit ? 'Edición de Matriz de Precios por Rango de Fechas' : 'Nueva Configuración de Precios por Rango de Fechas') }}
              </span>
              <v-chip v-if="isViewOnly" x-small color="amber darken-2" dark class="ml-2 font-weight-bold">
                <v-icon x-small left>mdi-eye</v-icon> SOLO LECTURA
              </v-chip>
            </div>
            <div class="header-subtitle">
              Operaciones Agrícolas · Asignación y Proyección Semanal
            </div>
          </div>
          <v-spacer></v-spacer>
          <div v-if="!isViewOnly" class="d-flex align-center mr-3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  outlined
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="rounded-lg text-none font-weight-bold"
                  style="border-color: rgba(255, 255, 255, 0.4);"
                  @click="openImportExcelModal()"
                >
                  <v-icon left small color="green accent-3">mdi-file-excel</v-icon>
                  Plantilla / Importar Excel
                </v-btn>
              </template>
              <span>Generar plantilla con IDs de productores e importar asignaciones masivas</span>
            </v-tooltip>
          </div>
          <v-btn icon small @click="closeDialogMatrix()" dark class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-5 bg-slate-50 modal-body">
          <!-- SECCIÓN 1: CABECERA DE PARÁMETROS -->
          <v-card outlined class="pa-4 mb-4 rounded-xl bg-white border-soft section-card">
            <div class="d-flex align-center mb-3">
              <div class="section-tag bg-blue-subtle mr-2">
                <v-icon x-small color="#2563eb">mdi-tune-vertical</v-icon>
              </div>
              <span class="text-subtitle-2 font-weight-bold text-slate-800">
                1. Parámetros del Rango, Cultivo, Variedad y Moneda
              </span>
            </div>

            <v-row dense class="align-center">
              <!-- Combo: Tipo Precio (def 1201) -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-select-definition
                  v-model="formAssignment.TypePrice"
                  :def="1201"
                  label="Tipo Precio"
                  :disabled="isViewOnly"
                  @input="onTypePriceChange($event)"
                ></s-select-definition>
              </v-col>

              <!-- Combo: Tipo de moneda (def 1129) -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-select-definition
                  v-model="formAssignment.TypeCurrency"
                  :def="1129"
                  label="Tipo de moneda"
                  :disabled="isViewOnly"
                ></s-select-definition>
              </v-col>

              <!-- Combo: Cultivo (def 1173) -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-select-definition
                  v-model="formAssignment.TypeCultive"
                  :def="1173"
                  label="Cultivo"
                  :disabled="isViewOnly"
                ></s-select-definition>
              </v-col>

              <!-- Combo: Variedad -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-select-variety
                  v-model="formAssignment.VrtID"
                  :cultiveID="formAssignment.TypeCultive"
                  label="Variedad"
                  :disabled="isViewOnly"
                ></s-select-variety>
              </v-col>
            </v-row>

            <v-row dense class="mt-2 align-center">
              <!-- Combo: Destino (def 1342) -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-select-definition
                  v-model="formAssignment.TypeDestiny"
                  :def="1342"
                  label="Destino"
                  :disabled="isViewOnly"
                ></s-select-definition>
              </v-col>

              <!-- Fecha Inicio -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-date
                  v-model="formAssignment.CfpDateBegin"
                  label="Fecha Inicio"
                  :disabled="isViewOnly"
                  @input="recalculateDateRange()"
                ></s-date>
              </v-col>

              <!-- Fecha Fin -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-date
                  v-model="formAssignment.CfpDateEnd"
                  label="Fecha Fin"
                  :disabled="isViewOnly"
                  @input="recalculateDateRange()"
                ></s-date>
              </v-col>

              <!-- Resumen Rango -->
              <v-col cols="12" md="3">
                <div class="pa-2 bg-slate-100 rounded-lg border-soft text-caption d-flex align-center justify-space-between">
                  <div>
                    <span class="font-weight-bold text-slate-800">Días en Matriz: </span>
                    <span class="font-weight-bold text-primary">{{ computedRangeDays.length }} días</span>
                  </div>
                  <div class="text-slate-500 font-weight-medium">
                    {{ formatDateDMY(formAssignment.CfpDateBegin) }} al {{ formatDateDMY(formAssignment.CfpDateEnd) }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>

          <!-- SECCIÓN 1.1: SELECCIÓN DE PRODUCTORES (SOLO PARA PRECIO ESPECIAL) -->
          <v-card v-if="isSpecialPrice" outlined class="pa-4 mb-4 rounded-xl bg-white border-soft section-card">
            <div class="d-flex align-center justify-space-between mb-3 flex-wrap">
              <div class="d-flex align-center">
                <div class="section-tag bg-purple-subtle mr-2">
                  <v-icon x-small color="#8b5cf6">mdi-account-star-outline</v-icon>
                </div>
                <div>
                  <span class="text-subtitle-2 font-weight-bold text-slate-800">
                    Productores con Precio Especial
                  </span>
                  <span class="text-caption text-slate-500 ml-2">
                    (Marque los productores para asignar su precio personalizado)
                  </span>
                </div>
              </div>
              <div class="d-flex align-center">
                <v-chip small color="#f3e8ff" class="font-weight-bold text-purple-800 mr-2 rounded-pill">
                  {{ formAssignment.SelectedProducers.length }} seleccionados
                </v-chip>
                <v-btn v-if="!isViewOnly" text x-small color="primary" class="font-weight-bold mr-1" @click="selectAllSpecialProducers()">
                  Seleccionar Todos
                </v-btn>
                <v-btn v-if="!isViewOnly" text x-small color="slate" class="font-weight-medium" @click="clearSpecialProducersSelection()">
                  Limpiar
                </v-btn>
              </div>
            </div>

            <!-- Buscador rápido de productores -->
            <v-text-field
              v-model="searchSpecialProducer"
              placeholder="Buscar por productor, carné o DNI/RUC..."
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              hide-details
              class="rounded-lg mb-3"
            ></v-text-field>

            <!-- Loading de Productores -->
            <div v-if="loadingProducers" class="py-4 text-center">
              <v-progress-circular indeterminate size="24" color="primary" class="mr-2"></v-progress-circular>
              <span class="text-caption text-slate-500">Cargando productores con precio especial...</span>
            </div>

            <!-- Estado Vacío -->
            <div v-else-if="filteredSpecialProducers.length === 0" class="pa-4 text-center text-caption text-slate-500">
              No se encontraron productores con precio especial con el criterio de búsqueda.
            </div>

            <!-- Grid de Productores con Checkbox -->
            <div v-else class="producer-grid-container">
              <div
                v-for="prd in filteredSpecialProducers"
                :key="'prd-' + prd.PrdID"
                class="producer-selection-card"
                :class="{ 'card-selected': selectedProducerIdsSet.has(prd.PrdID) }"
                @click="!isViewOnly && toggleProducerSelection(prd)"
              >
                <div class="d-flex align-center">
                  <v-checkbox
                    :input-value="selectedProducerIdsSet.has(prd.PrdID)"
                    dense
                    hide-details
                    :disabled="isViewOnly"
                    color="#8b5cf6"
                    class="ma-0 pa-0 mr-2"
                    @click.stop="!isViewOnly && toggleProducerSelection(prd)"
                  ></v-checkbox>
                  <div class="producer-info-wrap">
                    <div class="prd-name text-truncate">{{ prd.PrdCardName }}</div>
                    <div class="prd-meta text-caption text-slate-500">
                      <span>{{ prd.PrdCardCode || 'Sin carné' }}</span>
                      <span v-if="prd.DocumentNumber || prd.PrsDocumentNumber"> · {{ prd.DocumentNumber || prd.PrsDocumentNumber }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>

          <!-- SECCIÓN 2: SELECTOR DE CALIBRES (SOLO MODO EDICIÓN/NUEVO) -->
          <v-card v-if="!isViewOnly" outlined class="pa-4 mb-4 rounded-xl bg-white border-soft section-card">
            <div class="d-flex align-center mb-3">
              <div class="section-tag bg-emerald-subtle mr-2">
                <v-icon x-small color="#16a34a">mdi-scale-balance</v-icon>
              </div>
              <span class="text-subtitle-2 font-weight-bold text-slate-800">
                2. Agregar Tipo Calibre a la Matriz
              </span>
              <span class="text-caption text-slate-500 ml-2">
                (Filtrado por Cultivo / Destino)
              </span>
            </div>

            <v-row dense class="align-center">
              <v-col cols="12" md="8" class="s-col-form">
                <s-select-payment
                  v-if="canLoadCalibers"
                  :key="'caliber-sel-' + caliberSelectKey + '-' + formAssignment.TypeCultive + '-' + formAssignment.TypeDestiny"
                  full
                  noDefault
                  :noDefault="true"
                  :typeCultive="Number(formAssignment.TypeCultive)"
                  :TypeDestiny="Number(formAssignment.TypeDestiny)"
                  label="Tipo Calibre (Filtrado por Cultivo / Destino)"
                  v-model="selectedCaliber"
                  return-object
                  clearable
                ></s-select-payment>
                <div v-else class="pa-2 bg-slate-50 rounded-lg border-soft text-caption text-slate-500 d-flex align-center">
                  <v-icon small color="#f59e0b" class="mr-2">mdi-clock-outline</v-icon>
                  <span>Esperando selección de <b>Cultivo</b> y <b>Destino</b> para cargar los calibres correspondientes...</span>
                </div>
              </v-col>

              <v-col cols="12" md="4" class="d-flex align-center">
                <v-btn
                  color="#16a34a"
                  dark
                  :disabled="!canLoadCalibers || !selectedCaliber"
                  class="font-weight-bold elevation-0 rounded-lg px-4"
                  @click="addCaliberToMatrix()"
                >
                  <v-icon left small>mdi-plus-circle</v-icon> Agregar Calibre
                </v-btn>
              </v-col>
            </v-row>
          </v-card>

          <!-- SECCIÓN 3: MATRIZ DE PRECIOS POR CADA DÍA DEL RANGO -->
          <div class="d-flex align-center justify-space-between mb-2 flex-wrap">
            <div class="d-flex align-center">
              <div class="section-tag mr-2 bg-blue-subtle">
                <v-icon x-small color="#2563eb">mdi-table-clock</v-icon>
              </div>
              <span class="text-subtitle-2 font-weight-bold text-slate-800">
                3. Matriz de Asignación Diaria de Precios
              </span>
              <v-chip x-small color="#e2e8f0" class="ml-2 font-weight-bold text-slate-700">
                {{ currentCalibersMatrix.length }} calibres
              </v-chip>
            </div>
            <v-btn
              v-if="!isViewOnly"
              small
              outlined
              color="green darken-2"
              class="font-weight-bold rounded-lg text-none px-3"
              @click="openImportExcelModal()"
            >
              <v-icon left small>mdi-file-excel-box</v-icon>
              Plantilla / Importar Excel
            </v-btn>
          </div>

          <!-- PESTAÑAS CORPORATIVAS DE NAVEGACIÓN ENTRE PRODUCTORES (SOLO PRECIO ESPECIAL) -->
          <div
            v-if="isSpecialPrice && formAssignment.SelectedProducers.length > 0"
            class="producer-tabs-wrapper mb-3"
          >
            <!-- Barra Superior de Pestañas Horizontales Estilo ERP -->
            <div class="producer-tabs-header d-flex align-center justify-space-between pa-2 bg-slate-100 rounded-t-xl border-soft border-bottom-0">
              <div class="d-flex align-center overflow-x-auto producer-tabs-scroll flex-grow-1 pr-2">
                <div class="tabs-label-badge mr-2 flex-shrink-0">
                  <v-icon x-small color="#475569" class="mr-1">mdi-account-multiple</v-icon>
                  <span>PRODUCTORES ({{ formAssignment.SelectedProducers.length }}):</span>
                </div>

                <div
                  v-for="p in formAssignment.SelectedProducers"
                  :key="'tab-p-' + p.PrdID"
                  class="producer-tab-card mr-2"
                  :class="{ 'tab-card-active': activeProducerId === p.PrdID }"
                  @click="setActiveProducer(p.PrdID)"
                >
                  <div class="tab-card-avatar" :class="{ 'avatar-active': activeProducerId === p.PrdID }">
                    {{ getProducerInitials(p.PrdCardName) }}
                  </div>
                  <div class="tab-card-info">
                    <div class="tab-card-name text-truncate" :title="p.PrdCardName">
                      {{ p.PrdCardName }}
                    </div>
                    <div class="tab-card-code text-caption">
                      {{ p.PrdCardCode || 'Sin carné' }}
                    </div>
                  </div>
                  <v-icon x-small v-if="activeProducerId === p.PrdID" color="#2563eb" class="ml-1 flex-shrink-0">
                    mdi-check-circle
                  </v-icon>
                </div>
              </div>

              <!-- Acción de Replicar a Todos alineada elegantemente a la derecha -->
              <div class="flex-shrink-0" v-if="!isViewOnly && formAssignment.SelectedProducers.length > 1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      outlined
                      color="primary"
                      class="text-capitalize rounded-lg font-weight-bold px-3 btn-replicate elevation-0"
                      @click="replicateActiveProducerToAll()"
                    >
                      <v-icon x-small left>mdi-content-copy</v-icon>
                      Replicar a Todos
                    </v-btn>
                  </template>
                  <span>Copia la matriz de calibres y precios del productor activo a los demás seleccionados</span>
                </v-tooltip>
              </div>
            </div>

            <!-- Banner Informativo del Productor Activo + Botones de Acción de Matriz -->
            <div class="producer-active-banner pa-3 bg-white rounded-b-xl border-soft d-flex align-center justify-space-between flex-wrap">
              <div class="d-flex align-center">
                <div class="active-badge-icon mr-3">
                  <v-icon small color="#2563eb">mdi-account-check</v-icon>
                </div>
                <div>
                  <div class="d-flex align-center flex-wrap">
                    <span class="text-caption text-slate-500 mr-2">Configurando tarifas de:</span>
                    <span class="font-weight-bold text-slate-900 text-body-2 mr-2">
                      {{ activeProducerObj ? activeProducerObj.PrdCardName : 'Productor Especial' }}
                    </span>
                    <v-chip x-small color="#eff6ff" class="text-primary font-weight-bold rounded-pill">
                      {{ activeProducerObj && activeProducerObj.PrdCardCode ? activeProducerObj.PrdCardCode : 'Tarifa Individual' }}
                    </v-chip>
                  </div>
                  <div class="text-caption text-slate-500 mt-1">
                    Precios asignados individualmente para cada día y calibre de este productor.
                  </div>
                </div>
              </div>

              <!-- Acciones Rápidas de la Matriz Integradas a la derecha -->
              <div class="d-flex align-center flex-wrap mt-2 mt-sm-0" v-if="!isViewOnly && currentCalibersMatrix.length > 0">
                <button class="action-pill pill-blue mr-2" @click="replicateDay1ToAll()">
                  <v-icon x-small left color="#1d4ed8">mdi-content-duplicate</v-icon> Copiar Día 1
                </button>
                <button class="action-pill pill-indigo mr-2" v-if="currentCalibersMatrix.length > 1" @click="openCopyCaliberModal()">
                  <v-icon x-small left color="#4338ca">mdi-arrow-decision-outline</v-icon> Copiar Calibre
                </button>
                <button class="action-pill pill-purple mr-2" @click="applyPercentageVariation(5)">
                  <v-icon x-small left color="#475569">mdi-trending-up</v-icon> +5%
                </button>
                <button class="action-pill pill-red" @click="clearMatrixData()">
                  <v-icon x-small left color="#b91c1c">mdi-eraser</v-icon> Limpiar
                </button>
              </div>
            </div>
          </div>

          <!-- Si NO es precio especial (precio estándar normal), barra de acciones rápida estándar -->
          <div
            v-else-if="!isSpecialPrice && !isViewOnly && currentCalibersMatrix.length > 0"
            class="d-flex align-center justify-end mb-3 flex-wrap"
          >
            <button class="action-pill pill-blue mr-2" @click="replicateDay1ToAll()">
              <v-icon x-small left color="#1d4ed8">mdi-content-duplicate</v-icon> Copiar Día 1 a Todos los Días
            </button>
            <button class="action-pill pill-indigo mr-2" v-if="currentCalibersMatrix.length > 1" @click="openCopyCaliberModal()">
              <v-icon x-small left color="#4338ca">mdi-arrow-decision-outline</v-icon> Copiar Entre Calibres
            </button>
            <button class="action-pill pill-purple mr-2" @click="applyPercentageVariation(5)">
              <v-icon x-small left color="#475569">mdi-trending-up</v-icon> +5% Rango
            </button>
            <button class="action-pill pill-red" @click="clearMatrixData()">
              <v-icon x-small left color="#b91c1c">mdi-eraser</v-icon> Limpiar Valores
            </button>
          </div>

          <!-- Alerta si Precio Especial está activo pero no hay productores seleccionados -->
          <v-alert
            v-if="isSpecialPrice && formAssignment.SelectedProducers.length === 0"
            type="warning"
            dense
            outlined
            class="rounded-xl mb-3 font-weight-medium text-caption"
          >
            Debe marcar al menos un <b>Productor con Precio Especial</b> en la sección 1.1 para configurar y asignar sus precios diarios por calibre.
          </v-alert>

          <!-- ESTADO VACÍO CUANDO AÚN NO SE AGREGAN CALIBRES -->
          <v-card
            v-else-if="currentCalibersMatrix.length === 0"
            outlined
            class="pa-8 text-center rounded-xl bg-white border-dashed mb-3"
          >
            <div class="empty-icon-wrap mb-2">
              <v-icon size="42" color="#94a3b8">mdi-tray-plus</v-icon>
            </div>
            <div class="text-subtitle-2 font-weight-bold text-slate-700">
              No hay calibres agregados a la matriz {{ isSpecialPrice && activeProducerName ? 'de ' + activeProducerName : '' }}
            </div>
            <div class="text-caption text-slate-500 mt-1">
              Seleccione un <b>Tipo Calibre</b> en la sección 2 y haga clic en <b>"Agregar Calibre"</b> para armar la tabla diaria.
            </div>
          </v-card>

          <!-- TABLA MATRICIAL DE ALTO CONTRASTE ROBUSTA CON FUNCIÓN COPIAR ENTRE CALIBRES -->
          <v-card v-else outlined class="rounded-xl overflow-hidden elevation-0 border-soft mb-3 bg-white">
            <div style="overflow-x: auto;">
              <table class="custom-matrix-table">
                <thead>
                  <tr class="dark-header">
                    <th class="th-calibre text-left">Tipo Calibre</th>
                    <th
                      v-for="dayItem in computedRangeDays"
                      :key="'h-' + dayItem.dateKey"
                      class="th-day text-center"
                    >
                      <div class="day-title">{{ dayItem.dayName }}</div>
                      <div class="day-date">{{ dayItem.dateFormatted }}</div>
                    </th>
                    <th v-if="!isViewOnly" class="th-action text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(cal, cIndex) in currentCalibersMatrix"
                    :key="'cal-row-' + (isSpecialPrice ? activeProducerId + '-' : '') + cal.CtgID"
                    class="tr-price"
                  >
                    <td class="td-calibre font-weight-bold">
                      <div class="d-flex align-center">
                        <div class="cal-dot mr-2"></div>
                        <div>
                          <div class="calibre-name">{{ cal.CtgDescription }}</div>
                          <div class="calibre-group">{{ cal.CategoryGroup }}</div>
                        </div>
                      </div>
                    </td>
                    <td
                      v-for="dayItem in computedRangeDays"
                      :key="'p-col-' + (isSpecialPrice ? activeProducerId + '-' : '') + cal.CtgID + '-' + dayItem.dateKey"
                      class="td-input text-center pa-1"
                    >
                      <input
                        type="number"
                        step="0.05"
                        min="0"
                        :readonly="isViewOnly"
                        :disabled="isViewOnly"
                        :value="getCaliberPrice(cal, dayItem.dateKey)"
                        @keydown="preventNegativeInput($event)"
                        @input="updateCaliberPrice(cal, dayItem.dateKey, $event.target.value, $event)"
                        class="input-matrix price-input"
                        :class="{ 'input-view-only': isViewOnly }"
                        placeholder="0.00"
                      />
                    </td>
                    <!-- Columna de Acciones de la Fila (Copiar a otro Calibre + Quitar) -->
                    <td v-if="!isViewOnly" class="text-center td-actions">
                      <div class="d-flex align-center justify-center">
                        <!-- Botón Copiar este Calibre a Otro -->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              x-small
                              color="#4f46e5"
                              class="mr-1 btn-action-copy"
                              @click="openCopyCaliberModal(cal)"
                            >
                              <v-icon small>mdi-content-copy</v-icon>
                            </v-btn>
                          </template>
                          <span>Copiar precios de este calibre a otro</span>
                        </v-tooltip>

                        <!-- Botón Quitar Calibre -->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              x-small
                              color="#ef4444"
                              class="btn-action-delete"
                              @click="removeCaliberFromMatrix(cIndex)"
                            >
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Eliminar este calibre</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </v-card>

          <!-- Resumen Inferior y Observaciones -->
          <v-row dense class="align-center">
            <v-col cols="12" md="7">
              <v-text-field
                v-model="formAssignment.Observations"
                label="Observaciones de Gerencia Agrícola"
                placeholder="Notas sobre precios negociados o condiciones..."
                dense
                outlined
                hide-details
                :readonly="isViewOnly"
                :disabled="isViewOnly"
                background-color="white"
                class="rounded-lg"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <div class="summary-kpi-card pa-3 rounded-xl border-soft d-flex align-center justify-space-between bg-white">
                <div class="d-flex align-center">
                  <div class="kpi-icon-wrap mr-3">
                    <v-icon color="#0f766e" small>mdi-chart-line</v-icon>
                  </div>
                  <div>
                    <div class="summary-kpi-title">Promedio General Rango</div>
                    <div class="summary-kpi-subtitle">
                      {{ computedRangeDays.length }} días · {{ currentCalibersMatrix.length }} calibre(s)
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <div class="summary-kpi-value">
                    {{ formAssignment.TypeCurrency === 2 ? '$' : 'S/' }} {{ calculatedRangeAverage.toFixed(2) }}
                  </div>
                  <div class="summary-kpi-unit">por Kilogramo</div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4 bg-white d-flex justify-space-between modal-footer">
          <v-btn outlined color="#64748b" class="rounded-lg px-4 text-capitalize font-weight-medium" @click="closeDialogMatrix()">
            {{ isViewOnly ? 'Cerrar' : 'Cancelar' }}
          </v-btn>
          <div v-if="!isViewOnly">
            <v-btn color="#2563eb" dark class="elevation-1 rounded-lg font-weight-bold px-5 text-capitalize" @click="saveAssignment()">
              <v-icon left small>mdi-check-circle-outline</v-icon> Guardar Asignación por Rango
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ========================================================================================= -->
    <!-- DIÁLOGO CORPORATIVO: COPIAR PRECIOS SELECCIONANDO TANTO ORIGEN COMO DESTINO -->
    <!-- ========================================================================================= -->
    <v-dialog v-model="dialogCopyCaliber" persistent max-width="580px">
      <v-card class="rounded-2xl overflow-hidden copy-dialog-card">
        <!-- Header Claro Corporativo y Agradable -->
        <div class="px-5 py-4 d-flex align-center justify-space-between bg-white border-bottom">
          <div class="d-flex align-center">
            <div class="copy-icon-box mr-3">
              <v-icon color="#2563eb" small>mdi-content-copy</v-icon>
            </div>
            <div>
              <div class="text-subtitle-1 font-weight-bold text-slate-800">
                Copiar Precios entre Calibres
              </div>
              <div class="text-caption text-slate-500">
                Duplica precios diarios entre calibres fácilmente
              </div>
            </div>
          </div>
          <v-btn icon small @click="dialogCopyCaliber = false" color="#64748b" class="close-btn-light">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-5 bg-slate-50">
          <!-- Paso 1: Calibre Origen -->
          <div class="copy-step-card pa-4 mb-3 bg-white rounded-xl border-soft">
            <div class="d-flex align-center mb-1">
              <span class="step-badge step-badge-blue mr-2">1</span>
              <span class="font-weight-bold text-slate-800 text-body-2">
                Calibre de Origen (Copiar Desde):
              </span>
            </div>
            <div class="text-caption text-slate-500 mb-2">
              Elija el calibre cuyos valores diarios desea usar como plantilla.
            </div>

            <v-select
              v-model="copySourceCaliberId"
              :items="copySourceOptions"
              item-text="CtgDescription"
              item-value="CtgID"
              label="Seleccionar Calibre de Origen *"
              dense
              outlined
              class="rounded-lg select-corporate"
              hide-details
              @change="onSourceCaliberChange()"
              prepend-inner-icon="mdi-file-export-outline"
            ></v-select>
          </div>

          <!-- Paso 2: Calibre(s) Destino -->
          <div class="copy-step-card pa-4 mb-3 bg-white rounded-xl border-soft">
            <div class="d-flex align-center mb-1">
              <span class="step-badge step-badge-green mr-2">2</span>
              <span class="font-weight-bold text-slate-800 text-body-2">
                Calibre(s) de Destino (Copiar Hacia):
              </span>
            </div>
            <div class="text-caption text-slate-500 mb-2">
              Elija si desea replicar a todos los calibres restantes o a uno en particular.
            </div>

            <v-select
              v-model="copyTargetCaliberId"
              :items="copyTargetOptions"
              item-text="text"
              item-value="value"
              label="Seleccionar Calibre Destino *"
              dense
              outlined
              class="rounded-lg select-corporate"
              hide-details
              prepend-inner-icon="mdi-file-import-outline"
            ></v-select>

            <!-- Resumen Informativo Agradable -->
            <div class="mt-3 pa-2 rounded-lg bg-blue-subtle text-caption text-blue-800 d-flex align-center border-blue-subtle">
              <v-icon x-small color="#2563eb" class="mr-2">mdi-information-outline</v-icon>
              <span>{{ copyDestinationSummaryText }}</span>
            </div>
          </div>

          <!-- Nota Informativa de Replicación -->
          <div class="copy-step-card pa-3 bg-white rounded-xl border-soft d-flex align-center">
            <v-icon small color="#2563eb" class="mr-2">mdi-cash-multiple</v-icon>
            <span class="text-caption font-weight-medium text-slate-700">
              Se replicarán los precios por kilogramo establecidos para cada día del rango de fechas.
            </span>
          </div>
        </v-card-text>

        <div class="pa-4 bg-white border-top d-flex justify-space-between align-center">
          <v-btn
            outlined
            color="#64748b"
            class="rounded-lg px-4 text-capitalize font-weight-medium"
            @click="dialogCopyCaliber = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="#2563eb"
            dark
            class="rounded-lg px-5 text-capitalize font-weight-bold elevation-1"
            :disabled="!copySourceCaliberId"
            @click="applyCaliberCopy()"
          >
            <v-icon left small>mdi-check</v-icon> Aplicar Copia
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- MODAL DE DESCARGA DE PLANTILLA E IMPORTACIÓN MASIVA EXCEL -->
    <mango-price-import-modal
      v-model="showImportModal"
      :is-special-price="isSpecialPrice"
      :date-begin="formAssignment.CfpDateBegin || formAssignment.DateBegin"
      :date-end="formAssignment.CfpDateEnd || formAssignment.DateEnd"
      :range-days="computedRangeDays"
      :selected-producers="formAssignment.SelectedProducers"
      :all-special-producers="specialProducersList"
      :calibers-list="currentCalibersMatrix.length > 0 ? currentCalibersMatrix : formAssignment.CalibersMatrix"
      :type-cultive="formAssignment.TypeCultive"
      :type-destiny="formAssignment.TypeDestiny"
      @imported="onPricesImported($event)"
    />
  </div>
</template>

<script>
// Componentes Estándar del Sistema SunExpert
import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
import SDate from "@/components/Utils/SDate.vue";
import SSelectVariety from "@/components/HarvestSchedule/SSelectVariety";
import SSelectPayment from "@/components/CategoryPayment/SSelectPayment.vue";
import ProducerService from "@/services/Technicalassistance/ProducerService";
import ManagementPriceService from "@/services/Technicalassistance/ManagementPriceService";
import MangoPriceImportModal from "./MangoPriceImportModal.vue";

export default {
  name: "MangoPriceAssignmentDemo",
  components: {
    SSelectDefinition,
    SDate,
    SSelectVariety,
    SSelectPayment,
    MangoPriceImportModal,
  },
  data: () => ({
    search: "",
    dialogMatrix: false,
    showImportModal: false,
    isEdit: false,
    isViewOnly: false,
    loadingTable: false,
    totalRows: 0,
    tableOptions: {
      page: 1,
      itemsPerPage: 10,
    },

    // Diálogo de Copia entre Calibres
    dialogCopyCaliber: false,
    copySourceCaliberId: null, // Selector explícito de origen
    copyTargetCaliberId: 0, // 0: Todos los demás

    // Selector de Calibre activo
    selectedCaliber: null,
    caliberSelectKey: 0,

    // Productores con Precio Especial
    loadingProducers: false,
    specialProducersList: [],
    searchSpecialProducer: "",
    activeProducerId: null,

    // Control reactivo S-CRUD
    refreshTableToggle: false,
    selectedItem: null,

    // Filtros de búsqueda para S-CRUD
    filter: {
      TypePrice: null,
      TypeCurrency: null,
      TypeCultive: 1, // 1: Mango por defecto
      VrtID: null,
      TypeDestiny: null,
      DateBegin: null,
      DateEnd: null,
    },

    // Configuración canónica para el componente <s-crud>
    config: {
      title: "Asignación de Precios de Compra de Mango",
      service: ManagementPriceService,
      model: {
        MgpID: "ID",
        TypePrice: "int",
        TypePriceName: "string",
        TypeCurrency: "int",
        CurrencyName: "string",
        TypeCultive: "int",
        CultiveName: "string",
        VrtID: "int",
        VrtName: "string",
        TypeDestiny: "int",
        TypeDestinyName: "string",
        DateBegin: "date",
        DateEnd: "date",
        TotalDays: "int",
        CalibersCount: "int",
        AvgPriceCaliber: "decimal",
        SecStatus: "status",
      },
      headers: [
        { text: "Acciones", value: "actions", sortable: false, width: "95px", align: "center" },
        { text: "ID", value: "MgpID", width: "70px", align: "center", sortable: true },
        { text: "Tipo Precio", value: "TypePriceName", width: "130px", align: "center", sortable: true },
        { text: "Moneda", value: "CurrencyName", width: "95px", align: "center", sortable: true },
        { text: "Cultivo", value: "CultiveName", width: "100px", sortable: true },
        { text: "Variedad", value: "VrtName", width: "110px", sortable: true },
        { text: "Rango de Fechas", value: "DateRange", width: "210px", sortable: true },
        { text: "Calibres", value: "CalibersCount", width: "100px", align: "center", sortable: true },
        { text: "Destino", value: "TypeDestinyName", width: "110px", sortable: true },
        { text: "Precio Promedio", value: "AvgPriceCaliber", width: "130px", align: "end", sortable: true },
        { text: "Estado", value: "SecStatus", width: "100px", align: "center", sortable: true },
      ],
    },

    // Formulario de Asignación Normalizado con dbo.TasManagementPrice
    formAssignment: {
      MgpID: 0,
      CfpID: 0,
      TypePrice: 1, // 1: Estándar, 2 o 3: Especial (Definición 1201)
      TypeCurrency: 1,
      TypeCultive: 1, // Cultivo (def 1173)
      VrtID: null, // Variedad
      TypeDestiny: null, // Destino
      CfpDateBegin: "",
      CfpDateEnd: "",
      DateBegin: "",
      DateEnd: "",
      Observation: "",
      Observations: "",
      CalibersMatrix: [],
      SelectedProducers: [],
      ProducerCalibersMatrix: {},
    },

    // Días calculados por el Rango de Fechas
    computedRangeDays: [],

    // Registros de Configuraciones de Precios
    itemsAssignments: [],
  }),

  computed: {
    isSpecialPrice() {
      return this.formAssignment.TypePrice === 2 || this.formAssignment.TypePrice === 3;
    },

    selectedProducerIdsSet() {
      return new Set((this.formAssignment.SelectedProducers || []).map((p) => p.PrdID));
    },

    filteredSpecialProducers() {
      const list = this.specialProducersList || [];
      if (!this.searchSpecialProducer) return list;
      const q = this.searchSpecialProducer.toLowerCase().trim();
      return list.filter((p) => {
        const name = (p.PrdCardName || "").toLowerCase();
        const code = (p.PrdCardCode || "").toLowerCase();
        const doc = (p.DocumentNumber || p.PrsDocumentNumber || "").toLowerCase();
        return name.includes(q) || code.includes(q) || doc.includes(q);
      });
    },

    currentCalibersMatrix() {
      if (this.isSpecialPrice) {
        if (!this.activeProducerId) return [];
        return this.formAssignment.ProducerCalibersMatrix[this.activeProducerId] || [];
      }
      return this.formAssignment.CalibersMatrix || [];
    },

    activeProducerName() {
      if (!this.activeProducerId) return "";
      const prd = this.formAssignment.SelectedProducers.find((p) => p.PrdID === this.activeProducerId);
      return prd ? prd.PrdCardName : "";
    },

    activeProducerObj() {
      if (!this.activeProducerId) return null;
      return (
        this.formAssignment.SelectedProducers.find((p) => p.PrdID === this.activeProducerId) || null
      );
    },

    filteredItems() {
      return this.itemsAssignments.filter((item) => {
        if (this.filter.TypePrice && item.TypePrice !== this.filter.TypePrice) return false;
        if (this.filter.TypeCurrency && item.TypeCurrency !== this.filter.TypeCurrency) return false;
        if (this.filter.VrtID && item.VrtID !== this.filter.VrtID) return false;
        return true;
      });
    },

    calculatedRangeAverage() {
      const matrix = this.currentCalibersMatrix;
      const days = this.computedRangeDays;
      if (!matrix.length || !days.length) return 0;
      let total = 0;
      let count = 0;
      for (let i = 0; i < matrix.length; i++) {
        const dp = matrix[i].daysPrice;
        if (!dp) continue;
        for (let j = 0; j < days.length; j++) {
          const val = dp[days[j].dateKey];
          if (val > 0) {
            total += val;
            count++;
          }
        }
      }
      return count > 0 ? total / count : 0;
    },

    // Opciones para el selector de calibre origen
    copySourceOptions() {
      return this.currentCalibersMatrix.map((c) => ({
        CtgID: c.CtgID,
        CtgDescription: c.CtgDescription,
      }));
    },

    // Opciones para el selector de calibre destino
    copyTargetOptions() {
      const matrix = this.currentCalibersMatrix;
      const remainingCount = matrix.filter(
        (c) => c.CtgID !== this.copySourceCaliberId
      ).length;
      const options = [
        { text: `⭐ Todos los demás calibres restantes (${remainingCount})`, value: 0 },
      ];
      if (this.copySourceCaliberId) {
        matrix.forEach((c) => {
          if (c.CtgID !== this.copySourceCaliberId) {
            options.push({ text: c.CtgDescription, value: c.CtgID });
          }
        });
      }
      return options;
    },

    canLoadCalibers() {
      const c = parseInt(this.formAssignment.TypeCultive, 10);
      const d = parseInt(this.formAssignment.TypeDestiny, 10);
      return !isNaN(c) && c > 0 && !isNaN(d) && d > 0;
    },

    copyDestinationSummaryText() {
      if (!this.copySourceCaliberId) return "Seleccione primero un calibre de origen.";
      const matrix = this.currentCalibersMatrix;
      const source = matrix.find((c) => c.CtgID === this.copySourceCaliberId);
      const sourceName = source ? source.CtgDescription : "Origen";

      if (this.copyTargetCaliberId === 0) {
        const remaining = matrix.filter(
          (c) => c.CtgID !== this.copySourceCaliberId
        ).length;
        return `Se duplicarán los valores de '${sourceName}' hacia ${remaining} calibre(s) restantes de la matriz.`;
      }
      const target = matrix.find((c) => c.CtgID === this.copyTargetCaliberId);
      const targetName = target ? target.CtgDescription : "Destino";
      return `Se duplicarán los valores de '${sourceName}' únicamente hacia '${targetName}'.`;
    },
  },

  watch: {
    "formAssignment.TypeDestiny"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedCaliber = null;
        this.caliberSelectKey++;
      }
    },
    "formAssignment.TypeCultive"(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedCaliber = null;
        this.caliberSelectKey++;
      }
    },
  },

  mounted() {
    this.recalculateDateRange();
  },

  methods: {
    formatDateYMD(val) {
      if (!val) return "";
      if (typeof val === "string") {
        if (/^\d{4}-\d{2}-\d{2}/.test(val)) return val.substring(0, 10);
        const matchDMY = val.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
        if (matchDMY) return `${matchDMY[3]}-${matchDMY[2]}-${matchDMY[1]}`;
      }
      try {
        const d = new Date(val);
        if (!isNaN(d.getTime())) {
          const y = d.getFullYear();
          const m = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          return `${y}-${m}-${day}`;
        }
      } catch (e) {}
      return "";
    },

    formatDateDMY(val) {
      if (!val) return "";
      if (typeof val === "string") {
        const matchYMD = val.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (matchYMD) return `${matchYMD[3]}/${matchYMD[2]}/${matchYMD[1]}`;
        const matchDMY = val.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
        if (matchDMY) return `${matchDMY[1]}/${matchDMY[2]}/${matchDMY[3]}`;
      }
      try {
        const d = new Date(val);
        if (!isNaN(d.getTime())) {
          const y = d.getFullYear();
          const m = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          return `${day}/${m}/${y}`;
        }
      } catch (e) {}
      return "";
    },

    formatDateRange(begin, end) {
      const b = this.formatDateDMY(begin);
      const e = this.formatDateDMY(end);
      return b && e ? `${b} al ${e}` : (b || e || "");
    },

    refreshScrud() {
      this.refreshTableToggle = !this.refreshTableToggle;
      const ref = this.$refs.scrudManagementPrice;
      if (ref) {
        if (typeof ref.searchBtn === "function") {
          ref.searchBtn();
        } else if (typeof ref.refresh === "function") {
          ref.refresh();
        }
      }
    },

    rowSelected(items) {
      this.selectedItem = Array.isArray(items) && items.length > 0 ? items[0] : null;
    },

    edit(item) {
      const target = item || this.selectedItem;
      if (target) {
        this.viewDetailMatrix(target, false);
      }
    },

    getProducerInitials(name) {
      if (!name) return "PR";
      const parts = name.replace(/,/g, " ").trim().split(/\s+/).filter(Boolean);
      if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
      return (parts[0][0] + parts[1][0]).toUpperCase();
    },

    // =========================================================================
    // CARGA Y GESTIÓN DE PRODUCTORES CON PRECIO ESPECIAL
    // =========================================================================
    async loadSpecialProducers() {
      this.loadingProducers = true;
      try {
        const resp = await ProducerService.specialPrice();
        const data = resp && resp.data !== undefined ? resp.data : resp;
        if (Array.isArray(data)) {
          this.specialProducersList = data;
        } else if (data && data.data && Array.isArray(data.data)) {
          this.specialProducersList = data.data;
        } else {
          this.specialProducersList = [];
        }
      } catch (err) {
        console.error("Error al cargar productores con precio especial:", err);
        this.specialProducersList = [];
        this.notifyUser("No se pudo cargar la lista de productores especiales desde el servidor.", "warning");
      } finally {
        this.loadingProducers = false;
      }
    },

    onTypePriceChange(val) {
      if (val === 2 || val === 3) {
        if (this.specialProducersList.length === 0) {
          this.loadSpecialProducers();
        }
        if (this.formAssignment.SelectedProducers.length > 0 && !this.activeProducerId) {
          this.activeProducerId = this.formAssignment.SelectedProducers[0].PrdID;
        }
      }
    },

    isProducerSelected(prdId) {
      return this.selectedProducerIdsSet.has(prdId);
    },

    toggleProducerSelection(prd) {
      const idx = this.formAssignment.SelectedProducers.findIndex((p) => p.PrdID === prd.PrdID);
      if (idx >= 0) {
        this.formAssignment.SelectedProducers.splice(idx, 1);
        if (this.activeProducerId === prd.PrdID) {
          this.activeProducerId =
            this.formAssignment.SelectedProducers.length > 0
              ? this.formAssignment.SelectedProducers[0].PrdID
              : null;
        }
      } else {
        this.formAssignment.SelectedProducers.push(prd);
        this.initProducerMatrix(prd.PrdID);
        if (!this.activeProducerId) {
          this.activeProducerId = prd.PrdID;
        }
      }
    },

    selectAllSpecialProducers() {
      const list = this.filteredSpecialProducers;
      const currentSet = this.selectedProducerIdsSet;
      list.forEach((prd) => {
        if (!currentSet.has(prd.PrdID)) {
          this.formAssignment.SelectedProducers.push(prd);
          this.initProducerMatrix(prd.PrdID);
        }
      });
      if (!this.activeProducerId && this.formAssignment.SelectedProducers.length > 0) {
        this.activeProducerId = this.formAssignment.SelectedProducers[0].PrdID;
      }
    },

    clearSpecialProducersSelection() {
      this.formAssignment.SelectedProducers = [];
      this.activeProducerId = null;
    },

    setActiveProducer(prdId) {
      this.activeProducerId = prdId;
      this.initProducerMatrix(prdId);
    },

    cloneCalibersMatrix(matrix) {
      if (!Array.isArray(matrix)) return [];
      return matrix.map((c) => ({
        CtgID: c.CtgID,
        CtgDescription: c.CtgDescription,
        CategoryGroup: c.CategoryGroup || "Mango Exportación",
        daysPrice: { ...(c.daysPrice || {}) },
        MpdIDs: { ...(c.MpdIDs || {}) },
      }));
    },

    initProducerMatrix(prdId) {
      if (!this.formAssignment.ProducerCalibersMatrix[prdId]) {
        let baseCalibers = [];
        if (this.formAssignment.CalibersMatrix && this.formAssignment.CalibersMatrix.length > 0) {
          baseCalibers = this.formAssignment.CalibersMatrix;
        } else {
          const existingKeys = Object.keys(this.formAssignment.ProducerCalibersMatrix);
          if (existingKeys.length > 0 && this.formAssignment.ProducerCalibersMatrix[existingKeys[0]].length > 0) {
            baseCalibers = this.formAssignment.ProducerCalibersMatrix[existingKeys[0]];
          } else {
            baseCalibers = [];
          }
        }

        const newMatrix = baseCalibers.map((c) => {
          const daysPrice = {};
          this.computedRangeDays.forEach((d) => {
            daysPrice[d.dateKey] = c.daysPrice && c.daysPrice[d.dateKey] !== undefined ? c.daysPrice[d.dateKey] : 0;
          });
          return {
            CtgID: c.CtgID,
            CtgDescription: c.CtgDescription,
            CategoryGroup: c.CategoryGroup || "Mango Exportación",
            daysPrice,
            MpdIDs: {},
          };
        });

        this.$set(this.formAssignment.ProducerCalibersMatrix, prdId, newMatrix);
      }
    },

    replicateActiveProducerToAll() {
      if (!this.activeProducerId) return;
      const activeMatrix = this.formAssignment.ProducerCalibersMatrix[this.activeProducerId];
      if (!activeMatrix || activeMatrix.length === 0) {
        this.notifyUser("El productor activo no tiene calibres ni precios configurados para replicar.", "warning");
        return;
      }

      this.formAssignment.SelectedProducers.forEach((prd) => {
        if (prd.PrdID !== this.activeProducerId) {
          const cloned = this.cloneCalibersMatrix(activeMatrix);
          this.$set(this.formAssignment.ProducerCalibersMatrix, prd.PrdID, cloned);
        }
      });

      this.notifyUser(`Se replicaron los precios de '${this.activeProducerName}' a los demás productores seleccionados.`);
    },

    // =========================================================================
    // GESTIÓN DE RANGO DE FECHAS Y MATRIZ DIARIA
    // =========================================================================
    ensureMatrixDaysPrices(matrix) {
      if (!Array.isArray(matrix)) return;
      const days = this.computedRangeDays;
      matrix.forEach((cal) => {
        if (!cal.daysPrice) this.$set(cal, "daysPrice", {});

        // Obtener fechas y precios existentes ordenados
        const existingKeys = Object.keys(cal.daysPrice).sort();
        const existingValues = existingKeys.map((k) => cal.daysPrice[k]);
        const hasExistingPrices = existingValues.some((v) => v !== undefined && v !== null && v > 0);

        // Si hay días del nuevo rango sin definir
        const needsProjection = days.some((d) => cal.daysPrice[d.dateKey] === undefined);

        if (needsProjection && hasExistingPrices) {
          // Proyectar secuencialmente los precios existentes a los nuevos días
          days.forEach((d, idx) => {
            if (cal.daysPrice[d.dateKey] === undefined) {
              const fallback =
                idx < existingValues.length
                  ? existingValues[idx]
                  : existingValues[existingValues.length - 1] || 0;
              this.$set(cal.daysPrice, d.dateKey, fallback);
            }
          });
        } else {
          days.forEach((d) => {
            if (cal.daysPrice[d.dateKey] === undefined) {
              this.$set(cal.daysPrice, d.dateKey, 0);
            }
          });
        }
      });
    },

    recalculateDateRange() {
      const days = [];
      const dayNames = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
      
      const bStr = this.formatDateYMD(this.formAssignment.CfpDateBegin || this.formAssignment.DateBegin);
      const eStr = this.formatDateYMD(this.formAssignment.CfpDateEnd || this.formAssignment.DateEnd);

      let startDate = bStr ? new Date(bStr + "T00:00:00") : new Date();
      let endDate = eStr ? new Date(eStr + "T00:00:00") : new Date();

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()) || startDate > endDate) {
        startDate = new Date();
        endDate = new Date();
        endDate.setDate(startDate.getDate() + 6);
      }

      const curr = new Date(startDate);
      while (curr <= endDate) {
        const year = curr.getFullYear();
        const month = String(curr.getMonth() + 1).padStart(2, "0");
        const day = String(curr.getDate()).padStart(2, "0");
        const dateKey = `${year}-${month}-${day}`;
        const dateFormatted = `${day}/${month}`;
        const dayName = dayNames[curr.getDay()];

        days.push({
          dateKey,
          dateFormatted,
          dayName,
        });

        curr.setDate(curr.getDate() + 1);
      }

      this.computedRangeDays = days;

      // Garantizar reactividad de Vue 2 con $set
      this.ensureMatrixDaysPrices(this.formAssignment.CalibersMatrix);
      if (this.formAssignment.ProducerCalibersMatrix) {
        Object.values(this.formAssignment.ProducerCalibersMatrix).forEach((matrix) => {
          this.ensureMatrixDaysPrices(matrix);
        });
      }
    },

    getCaliberPrice(cal, dateKey) {
      if (!cal || !cal.daysPrice) return 0;
      const val = cal.daysPrice[dateKey];
      return val !== undefined && val !== null ? Math.max(0, Number(val)) : 0;
    },

    preventNegativeInput(e) {
      if (e.key === "-" || e.key === "e" || e.key === "E" || e.keyCode === 189 || e.keyCode === 109) {
        e.preventDefault();
      }
    },

    updateCaliberPrice(cal, dateKey, val, event = null) {
      if (!cal.daysPrice) this.$set(cal, "daysPrice", {});
      let parsed = parseFloat(val);
      if (isNaN(parsed) || parsed < 0) {
        parsed = 0;
        if (event && event.target && val !== "" && val !== "0") {
          event.target.value = 0;
        }
      }
      this.$set(cal.daysPrice, dateKey, parsed);
    },

    addCaliberToMatrix() {
      let ctgID = null;
      let ctgDesc = "";

      if (this.selectedCaliber) {
        if (typeof this.selectedCaliber === "object") {
          const rawId = this.selectedCaliber.CtgID !== undefined ? this.selectedCaliber.CtgID : this.selectedCaliber.value;
          ctgID = parseInt(rawId, 10);
          ctgDesc =
            this.selectedCaliber.CtgDescription ||
            this.selectedCaliber.CategoryCaliberText ||
            this.selectedCaliber.text ||
            "";
        } else {
          ctgID = parseInt(this.selectedCaliber, 10);
        }
      }

      if (!ctgID || isNaN(ctgID) || ctgID <= 0) {
        this.notifyUser("Seleccione un Tipo Calibre válido de la lista antes de agregar.", "warning");
        return;
      }

      if (!ctgDesc) {
        ctgDesc = `Calibre ${ctgID}`;
      }

      if (this.isSpecialPrice && this.formAssignment.SelectedProducers.length === 0) {
        this.notifyUser("Seleccione al menos un productor con precio especial antes de agregar calibres.", "warning");
        return;
      }

      const targetMatrix = this.currentCalibersMatrix;

      if (targetMatrix.some((c) => parseInt(c.CtgID, 10) === ctgID)) {
        this.notifyUser("Este calibre ya se encuentra agregado en la matriz.", "warning");
        return;
      }

      const daysPrice = {};
      const mpdIDs = {};
      this.computedRangeDays.forEach((d) => {
        daysPrice[d.dateKey] = 0;
        mpdIDs[d.dateKey] = 0;
      });

      const newCaliber = {
        CtgID: ctgID,
        CtgDescription: ctgDesc,
        CategoryGroup: "Mango Exportación",
        daysPrice,
        MpdIDs: mpdIDs,
      };

      if (this.isSpecialPrice) {
        targetMatrix.push(newCaliber);
        this.formAssignment.SelectedProducers.forEach((p) => {
          if (p.PrdID !== this.activeProducerId) {
            const pMatrix = this.formAssignment.ProducerCalibersMatrix[p.PrdID];
            if (pMatrix && !pMatrix.some((c) => parseInt(c.CtgID, 10) === ctgID)) {
              pMatrix.push({
                ...newCaliber,
                daysPrice: { ...daysPrice },
                MpdIDs: { ...mpdIDs },
              });
            }
          }
        });
      } else {
        this.formAssignment.CalibersMatrix.push(newCaliber);
      }

      this.selectedCaliber = null;
      this.caliberSelectKey++;
      this.notifyUser(`Se agregó el calibre '${ctgDesc}' a la matriz.`);
    },

    removeCaliberFromMatrix(index) {
      this.currentCalibersMatrix.splice(index, 1);
    },

    // =========================================================================
    // COPIAR PRECIOS ENTRE CALIBRES
    // =========================================================================
    openCopyCaliberModal(sourceCal = null) {
      const matrix = this.currentCalibersMatrix;
      if (sourceCal && sourceCal.CtgID) {
        this.copySourceCaliberId = sourceCal.CtgID;
      } else if (!this.copySourceCaliberId && matrix.length > 0) {
        this.copySourceCaliberId = matrix[0].CtgID;
      }

      this.copyTargetCaliberId = 0;
      this.dialogCopyCaliber = true;
    },

    onSourceCaliberChange() {
      if (this.copyTargetCaliberId === this.copySourceCaliberId) {
        this.copyTargetCaliberId = 0;
      }
    },

    applyCaliberCopy() {
      if (!this.copySourceCaliberId) {
        this.notifyUser("Seleccione un Calibre de Origen para copiar.", "warning");
        return;
      }

      const matrix = this.currentCalibersMatrix;
      const sourceCal = matrix.find((c) => c.CtgID === this.copySourceCaliberId);
      if (!sourceCal) {
        this.notifyUser("Calibre de origen no encontrado en la matriz.", "warning");
        return;
      }

      let targets = [];
      if (this.copyTargetCaliberId === 0) {
        targets = matrix.filter((c) => c.CtgID !== sourceCal.CtgID);
      } else {
        const target = matrix.find((c) => c.CtgID === this.copyTargetCaliberId);
        if (target) targets = [target];
      }

      if (targets.length === 0) {
        this.notifyUser("No hay calibres destino seleccionados para copiar.", "warning");
        return;
      }

      targets.forEach((targetCal) => {
        if (!targetCal.daysPrice) this.$set(targetCal, "daysPrice", {});
        this.computedRangeDays.forEach((day) => {
          const priceVal = this.getCaliberPrice(sourceCal, day.dateKey);
          this.$set(targetCal.daysPrice, day.dateKey, priceVal);
        });
      });

      this.dialogCopyCaliber = false;
      const targetLabel = this.copyTargetCaliberId === 0 ? "todos los demás calibres" : targets[0].CtgDescription;
      this.notifyUser(`Se copiaron los precios de '${sourceCal.CtgDescription}' hacia ${targetLabel} exitosamente.`);
    },

    // =========================================================================
    // ACCIONES RÁPIDAS
    // =========================================================================
    replicateDay1ToAll() {
      if (!this.computedRangeDays.length) return;
      const firstKey = this.computedRangeDays[0].dateKey;

      this.currentCalibersMatrix.forEach((cal) => {
        const firstPrice = this.getCaliberPrice(cal, firstKey);
        if (!cal.daysPrice) this.$set(cal, "daysPrice", {});
        this.computedRangeDays.forEach((day) => {
          this.$set(cal.daysPrice, day.dateKey, firstPrice);
        });
      });
      this.notifyUser("Se replicaron los precios del primer día a todo el rango de fechas.");
    },

    applyPercentageVariation(pct) {
      const factor = 1 + pct / 100;
      this.currentCalibersMatrix.forEach((cal) => {
        if (!cal.daysPrice) this.$set(cal, "daysPrice", {});
        this.computedRangeDays.forEach((day) => {
          const currentPrice = this.getCaliberPrice(cal, day.dateKey);
          const newPrice = Math.round(currentPrice * factor * 100) / 100;
          this.$set(cal.daysPrice, day.dateKey, newPrice);
        });
      });
      this.notifyUser(`Se aplicó una variación de +${pct}% a todo el rango de fechas.`);
    },

    clearMatrixData() {
      this.currentCalibersMatrix.forEach((cal) => {
        if (!cal.daysPrice) this.$set(cal, "daysPrice", {});
        this.computedRangeDays.forEach((day) => {
          this.$set(cal.daysPrice, day.dateKey, 0);
        });
      });
    },

    // =========================================================================
    // OPERACIONES CRUD Y PERSISTENCIA NORMALIZADA
    // =========================================================================
    openDialogNewAssignment() {
      this.resetModalForm();
      const now = new Date();
      const next6 = new Date();
      next6.setDate(now.getDate() + 6);
      const bStr = this.formatDateYMD(now) || "2026-10-14";
      const eStr = this.formatDateYMD(next6) || "2026-10-20";

      this.isEdit = false;
      this.isViewOnly = false;
      this.formAssignment.TypeCultive = 1; // Mango
      this.formAssignment.TypeDestiny = 1; // Frescas (def 1342)
      this.formAssignment.CfpDateBegin = bStr;
      this.formAssignment.CfpDateEnd = eStr;
      this.formAssignment.DateBegin = bStr;
      this.formAssignment.DateEnd = eStr;
      this.recalculateDateRange();
      this.dialogMatrix = true;
    },

    buildCalibersFromDetails(detailList) {
      const calibersMap = {};
      if (!Array.isArray(detailList)) return [];

      detailList.forEach((d) => {
        const ctgId = d.CtgID || d.ctgID;
        if (!ctgId) return;

        if (!calibersMap[ctgId]) {
          calibersMap[ctgId] = {
            CtgID: ctgId,
            CtgDescription: d.CtgDescription || d.ctgDescription || `Calibre ${ctgId}`,
            CategoryGroup: "Mango Exportación",
            daysPrice: {},
            MpdIDs: {},
          };
        }
        const dateStr = this.formatDateYMD(d.Date || d.date);
        const rawPrice = d.Price !== undefined && d.Price !== null ? d.Price : d.price;
        calibersMap[ctgId].daysPrice[dateStr] = rawPrice !== undefined && rawPrice !== null ? Number(rawPrice) : 0;
        const mpdId = d.MpdID || d.mpdID;
        if (mpdId) calibersMap[ctgId].MpdIDs[dateStr] = mpdId;
      });

      return Object.values(calibersMap);
    },

    async viewDetailMatrix(item, viewOnly = false) {
      this.resetModalForm();
      this.isViewOnly = Boolean(viewOnly);
      this.isEdit = !viewOnly;
      const mgpID = item.MgpID || item.CfpID;
      this.formAssignment.MgpID = mgpID;
      this.formAssignment.CfpID = mgpID;
      this.formAssignment.TypePrice = item.TypePrice || 1;
      this.formAssignment.TypeCurrency = item.TypeCurrency || 1;
      this.formAssignment.TypeCultive = item.TypeCultive || 1;
      this.formAssignment.VrtID = item.VrtID || 1;
      this.formAssignment.TypeDestiny = item.TypeDestiny || 1;

      const bStr = this.formatDateYMD(item.DateBegin || item.CfpDateBegin);
      const eStr = this.formatDateYMD(item.DateEnd || item.CfpDateEnd);
      this.formAssignment.CfpDateBegin = bStr || "2026-10-06";
      this.formAssignment.CfpDateEnd = eStr || "2026-10-12";
      this.formAssignment.DateBegin = this.formAssignment.CfpDateBegin;
      this.formAssignment.DateEnd = this.formAssignment.CfpDateEnd;
      this.formAssignment.Observation = item.Observation || item.Observations || "";
      this.formAssignment.Observations = this.formAssignment.Observation;
      this.formAssignment.SelectedProducers = item.SelectedProducers ? [...item.SelectedProducers] : [];
      this.formAssignment.ProducerCalibersMatrix = {};
      this.formAssignment.CalibersMatrix = [];
      this.recalculateDateRange();

      const requestID = (this.$fun && typeof this.$fun.getUserID === "function" && this.$fun.getUserID()) || 1;

      try {
        const res = await ManagementPriceService.getById(mgpID, requestID);
        const data = res && res.data !== undefined ? res.data : res;
        const details = Array.isArray(data) ? data : (data && data.Details ? data.Details : null);

        if (details && details.length > 0) {
          const detailDates = details.map((d) => this.formatDateYMD(d.Date || d.date)).filter(Boolean).sort();
          if (detailDates.length > 0) {
            this.formAssignment.CfpDateBegin = detailDates[0];
            this.formAssignment.CfpDateEnd = detailDates[detailDates.length - 1];
            this.formAssignment.DateBegin = this.formAssignment.CfpDateBegin;
            this.formAssignment.DateEnd = this.formAssignment.CfpDateEnd;
          }

          if (this.isSpecialPrice) {
            const producersMap = {};
            const detailsByProducer = {};

            details.forEach((d) => {
              const prdId = d.PrdID || d.prdID;
              if (prdId) {
                if (!producersMap[prdId]) {
                  producersMap[prdId] = {
                    PrdID: prdId,
                    PrdCardName: d.PrdCardName || d.prdCardName || `Productor ${prdId}`,
                    PrdCardCode: d.PrdCardCode || d.prdCardCode || `PRD-${prdId}`,
                  };
                  detailsByProducer[prdId] = [];
                }
                detailsByProducer[prdId].push(d);
              }
            });

            this.formAssignment.SelectedProducers = Object.values(producersMap);

            this.formAssignment.SelectedProducers.forEach((prd) => {
              const calibers = this.buildCalibersFromDetails(detailsByProducer[prd.PrdID] || []);
              this.$set(this.formAssignment.ProducerCalibersMatrix, prd.PrdID, calibers);
            });

            if (this.formAssignment.SelectedProducers.length > 0) {
              this.activeProducerId = this.formAssignment.SelectedProducers[0].PrdID;
            }
          } else {
            this.formAssignment.CalibersMatrix = this.buildCalibersFromDetails(details);
          }

          this.recalculateDateRange();
          this.dialogMatrix = true;
          return;
        } else {
          this.notifyUser("No se encontraron detalles de precios para esta asignación.", "warning");
        }
      } catch (err) {
        console.error("Error al cargar detalles de la asignación:", err);
        const errMsg = (err.response && err.response.data && (err.response.data.Message || err.response.data)) || err.message;
        this.notifyUser("Error al consultar detalles: " + errMsg, "error");
      }

      this.recalculateDateRange();
      this.dialogMatrix = true;
    },

    closeDialogMatrix() {
      this.dialogMatrix = false;
      this.resetModalForm();
    },

    resetModalForm() {
      this.selectedCaliber = null;
      this.caliberSelectKey++;
      this.activeProducerId = null;
      this.searchSpecialProducer = "";
      this.isEdit = false;
      this.isViewOnly = false;
      this.formAssignment = {
        CfpID: 0,
        MgpID: 0,
        TypePrice: 1,
        TypeCurrency: 1,
        TypeCultive: 1,
        VrtID: null,
        TypeDestiny: null,
        CfpDateBegin: "",
        CfpDateEnd: "",
        DateBegin: "",
        DateEnd: "",
        Observations: "",
        Observation: "",
        CalibersMatrix: [],
        SelectedProducers: [],
        ProducerCalibersMatrix: {},
      };
      this.computedRangeDays = [];
    },

    deleteAssignment(item) {
      const target = item || this.selectedItem;
      if (!target || !target.MgpID) {
        this.notifyUser("Seleccione una asignación de precios para eliminar.", "warning");
        return;
      }

      const alertFunc = this.$fun && typeof this.$fun.alert === "function" ? this.$fun.alert : null;
      if (alertFunc) {
        alertFunc("¿Está seguro de eliminar esta asignación de precios?", "question").then(async (val) => {
          if (val && (val.value || val.isConfirmed)) {
            await this.executeDelete(target);
          }
        });
      } else {
        if (confirm("¿Está seguro de eliminar esta asignación de precios?")) {
          this.executeDelete(target);
        }
      }
    },

    async executeDelete(target) {
      try {
        const requestID = (this.$fun && typeof this.$fun.getUserID === "function" && this.$fun.getUserID()) || 1;
        const payload = {
          MgpID: parseInt(target.MgpID, 10),
          TypePrice: parseInt(target.TypePrice || 1, 10),
          TypeCurrency: parseInt(target.TypeCurrency || 1, 10),
          TypeCultive: parseInt(target.TypeCultive || 1, 10),
          VrtID: parseInt(target.VrtID || 1, 10),
          TypeDestiny: parseInt(target.TypeDestiny || 1, 10),
          DateBegin: this.formatDateYMD(target.DateBegin || target.CfpDateBegin),
          DateEnd: this.formatDateYMD(target.DateEnd || target.CfpDateEnd),
          Observation: (target.Observation || target.Observations || "").trim(),
          SecStatus: 0,
          UsrUpdateID: requestID,
        };

        this.loadingTable = true;
        await ManagementPriceService.save(payload, requestID);
        this.notifyUser("Asignación de precios eliminada correctamente.");
        this.refreshScrud();
      } catch (err) {
        console.error("Error al eliminar asignación:", err);
        const errMsg = (err.response && err.response.data && (err.response.data.Message || err.response.data)) || err.message;
        this.notifyUser("Error al eliminar: " + errMsg, "error");
      } finally {
        this.loadingTable = false;
      }
    },

    async duplicateAssignment(item) {
      this.resetModalForm();
      this.isEdit = false;
      this.isViewOnly = false;
      const mgpID = item.MgpID || item.CfpID;
      this.formAssignment.MgpID = 0;
      this.formAssignment.CfpID = 0;
      this.formAssignment.TypePrice = item.TypePrice || 1;
      this.formAssignment.TypeCurrency = item.TypeCurrency || 1;
      this.formAssignment.TypeCultive = item.TypeCultive || 1;
      this.formAssignment.VrtID = item.VrtID || 1;
      this.formAssignment.TypeDestiny = item.TypeDestiny || 1;
      this.formAssignment.Observation = item.Observation || item.Observations || "";
      this.formAssignment.Observations = this.formAssignment.Observation;
      this.formAssignment.SelectedProducers = item.SelectedProducers ? [...item.SelectedProducers] : [];
      this.formAssignment.ProducerCalibersMatrix = {};
      this.formAssignment.CalibersMatrix = [];

      // Calcular nuevo rango de fechas sugerido (la semana siguiente)
      const bStr = this.formatDateYMD(item.DateBegin || item.CfpDateBegin);
      const eStr = this.formatDateYMD(item.DateEnd || item.CfpDateEnd);
      let nextStartStr = "";
      let nextEndStr = "";

      if (bStr && eStr) {
        const dStart = new Date(bStr + "T00:00:00");
        const dEnd = new Date(eStr + "T00:00:00");
        const diffDays = Math.max(1, Math.round((dEnd - dStart) / (1000 * 60 * 60 * 24)) + 1);

        const nextStart = new Date(dEnd);
        nextStart.setDate(nextStart.getDate() + 1);
        const nextEnd = new Date(nextStart);
        nextEnd.setDate(nextStart.getDate() + diffDays - 1);

        nextStartStr = this.formatDateYMD(nextStart);
        nextEndStr = this.formatDateYMD(nextEnd);
      }

      this.formAssignment.CfpDateBegin = nextStartStr || bStr || "2026-10-13";
      this.formAssignment.CfpDateEnd = nextEndStr || eStr || "2026-10-19";
      this.formAssignment.DateBegin = this.formAssignment.CfpDateBegin;
      this.formAssignment.DateEnd = this.formAssignment.CfpDateEnd;

      this.recalculateDateRange();

      const requestID = (this.$fun && typeof this.$fun.getUserID === "function" && this.$fun.getUserID()) || 1;

      try {
        const res = await ManagementPriceService.getById(mgpID, requestID);
        const data = res && res.data !== undefined ? res.data : res;
        const details = Array.isArray(data) ? data : (data && data.Details ? data.Details : null);

        if (details && details.length > 0) {
          // Extraer fechas ordenadas originales de los detalles
          const oldDates = [...new Set(details.map((d) => this.formatDateYMD(d.Date || d.date)).filter(Boolean))].sort();

          const projectToNewDays = (calibers) => {
            return calibers.map((c) => {
              const newDaysPrice = {};
              const newMpdIDs = {};
              const oldPricesList = oldDates.map((od) => (c.daysPrice[od] !== undefined ? c.daysPrice[od] : 0));

              this.computedRangeDays.forEach((newDay, idx) => {
                const priceVal =
                  idx < oldPricesList.length
                    ? oldPricesList[idx]
                    : oldPricesList[oldPricesList.length - 1] || 0;
                newDaysPrice[newDay.dateKey] = priceVal;
                newMpdIDs[newDay.dateKey] = 0; // Registro nuevo
              });

              return {
                ...c,
                daysPrice: newDaysPrice,
                MpdIDs: newMpdIDs,
              };
            });
          };

          if (this.isSpecialPrice) {
            const producersMap = {};
            const detailsByProducer = {};

            details.forEach((d) => {
              const prdId = d.PrdID || d.prdID;
              if (prdId) {
                if (!producersMap[prdId]) {
                  producersMap[prdId] = {
                    PrdID: prdId,
                    PrdCardName: d.PrdCardName || d.prdCardName || `Productor ${prdId}`,
                    PrdCardCode: d.PrdCardCode || d.prdCardCode || `PRD-${prdId}`,
                  };
                  detailsByProducer[prdId] = [];
                }
                detailsByProducer[prdId].push(d);
              }
            });

            this.formAssignment.SelectedProducers = Object.values(producersMap);

            this.formAssignment.SelectedProducers.forEach((prd) => {
              const baseCalibers = this.buildCalibersFromDetails(detailsByProducer[prd.PrdID] || []);
              const projected = projectToNewDays(baseCalibers);
              this.$set(this.formAssignment.ProducerCalibersMatrix, prd.PrdID, projected);
            });

            if (this.formAssignment.SelectedProducers.length > 0) {
              this.activeProducerId = this.formAssignment.SelectedProducers[0].PrdID;
            }
          } else {
            const baseCalibers = this.buildCalibersFromDetails(details);
            this.formAssignment.CalibersMatrix = projectToNewDays(baseCalibers);
          }

          this.recalculateDateRange();
          this.dialogMatrix = true;
          this.notifyUser(`Configuración cargada como nueva plantilla. Asignada para el rango ${this.formAssignment.CfpDateBegin} al ${this.formAssignment.CfpDateEnd}.`);
          return;
        } else {
          this.notifyUser("No se encontraron detalles de precios en la asignación original para duplicar.", "warning");
        }
      } catch (err) {
        console.error("Error al duplicar asignación:", err);
        const errMsg = (err.response && err.response.data && (err.response.data.Message || err.response.data)) || err.message;
        this.notifyUser("Error al consultar detalles para duplicar: " + errMsg, "error");
      }

      this.recalculateDateRange();
      this.dialogMatrix = true;
    },

    approveAssignment(item) {
      item.Status = 3;
      item.StatusName = "Vigente";
      this.notifyUser(`Asignación #${item.CfpID} aprobada exitosamente.`);
    },

    async saveAssignment() {
      if (this.isSpecialPrice) {
        if (!this.formAssignment.SelectedProducers || this.formAssignment.SelectedProducers.length === 0) {
          this.notifyUser("Para precio especial debe seleccionar al menos un productor.", "warning");
          return;
        }
        if (!this.currentCalibersMatrix || this.currentCalibersMatrix.length === 0) {
          this.notifyUser("Debe agregar calibres y precios para los productores seleccionados.", "warning");
          return;
        }
      } else {
        if (!this.formAssignment.CalibersMatrix || this.formAssignment.CalibersMatrix.length === 0) {
          this.notifyUser("Debe agregar al menos un calibre a la matriz antes de guardar.", "warning");
          return;
        }
      }

      const bDate = this.formatDateYMD(this.formAssignment.CfpDateBegin || this.formAssignment.DateBegin);
      const eDate = this.formatDateYMD(this.formAssignment.CfpDateEnd || this.formAssignment.DateEnd);

      if (!bDate || !eDate) {
        this.notifyUser("Debe definir una fecha de inicio y fin válidas.", "warning");
        return;
      }
      if (bDate > eDate) {
        this.notifyUser("La fecha de inicio no puede ser posterior a la fecha de fin.", "warning");
        return;
      }

      const requestID = (this.$fun && typeof this.$fun.getUserID === "function" && this.$fun.getUserID()) || 1;
      const mgpId = parseInt(this.formAssignment.MgpID || 0, 10);
      const days = this.computedRangeDays;
      const payloadDetails = [];

      const buildDetailsFromMatrix = (matrix, prdId = null) => {
        if (!Array.isArray(matrix)) return;
        matrix.forEach((cal) => {
          const ctgID = parseInt(cal.CtgID, 10);
          if (!ctgID || isNaN(ctgID) || ctgID <= 0) return;

          days.forEach((day) => {
            const price = Math.max(0, parseFloat(this.getCaliberPrice(cal, day.dateKey)) || 0);
            payloadDetails.push({
              MpdID: (cal.MpdIDs && cal.MpdIDs[day.dateKey]) ? parseInt(cal.MpdIDs[day.dateKey], 10) : 0,
              MgpID: mgpId,
              PrdID: prdId,
              CtgID: ctgID,
              Date: day.dateKey,
              Price: price,
              SecStatus: 1,
              UsrCreateID: requestID,
              UsrUpdateID: requestID,
            });
          });
        });
      };

      if (this.isSpecialPrice) {
        this.formAssignment.SelectedProducers.forEach((p) => {
          const prdId = parseInt(p.PrdID, 10);
          if (!prdId || isNaN(prdId) || prdId <= 0) return;
          buildDetailsFromMatrix(this.formAssignment.ProducerCalibersMatrix[p.PrdID], prdId);
        });
      } else {
        buildDetailsFromMatrix(this.formAssignment.CalibersMatrix, null);
      }

      if (payloadDetails.length === 0) {
        this.notifyUser("No hay calibres válidos configurados para guardar en la base de datos.", "warning");
        return;
      }

      const payloadHeader = {
        MgpID: mgpId,
        TypePrice: parseInt(this.formAssignment.TypePrice, 10),
        TypeCurrency: parseInt(this.formAssignment.TypeCurrency, 10),
        TypeCultive: parseInt(this.formAssignment.TypeCultive || 1, 10),
        VrtID: parseInt(this.formAssignment.VrtID || 1, 10),
        TypeDestiny: parseInt(this.formAssignment.TypeDestiny || 1, 10),
        DateBegin: bDate,
        DateEnd: eDate,
        Observation: (this.formAssignment.Observation || this.formAssignment.Observations || "").trim(),
        SecStatus: 1,
        UsrCreateID: requestID,
        UsrUpdateID: requestID,
        TasManagementPriceDetail: payloadDetails,
      };

      try {
        this.loadingTable = true;
        await ManagementPriceService.save(payloadHeader, requestID);
        this.notifyUser("Configuración de precios guardada en el servidor exitosamente.");
        this.closeDialogMatrix();
        this.refreshScrud();
      } catch (err) {
        console.error("Error al guardar en servidor:", err);
        const errMsg = (err.response && err.response.data && (err.response.data.Message || err.response.data)) || err.message;
        this.notifyUser("Error al registrar en base de datos: " + errMsg, "error");
      } finally {
        this.loadingTable = false;
      }
    },

    resetFilters() {
      this.filter = {
        TypePrice: null,
        TypeCurrency: null,
        TypeCultive: 1,
        VrtID: null,
        TypeDestiny: null,
        CfpDateBegin: "2026-10-06",
        CfpDateEnd: "2026-10-12",
      };
    },

    getStatusColor(status) {
      switch (status) {
        case 1:
          return "#94a3b8";
        case 2:
          return "#f59e0b";
        case 3:
          return "#10b981";
        default:
          return "#2563eb";
      }
    },

    notifyUser(msg, type = "success") {
      if (this.$fun && typeof this.$fun.alert === "function") {
        this.$fun.alert(msg, type);
      } else {
        console.log(msg);
      }
    },

    openImportExcelModal() {
      if (this.isSpecialPrice && (!this.specialProducersList || this.specialProducersList.length === 0)) {
        this.loadSpecialProducers();
      }
      this.showImportModal = true;
    },

    onPricesImported(payload) {
      const { isSpecialPrice, producers, calibersByProducer, standardCalibers } = payload;

      if (isSpecialPrice) {
        // 1. Fusionar productores manteniendo reactividad
        const currentIds = new Set((this.formAssignment.SelectedProducers || []).map((p) => p.PrdID));
        (producers || []).forEach((p) => {
          if (!currentIds.has(p.PrdID)) {
            this.formAssignment.SelectedProducers.push(p);
            currentIds.add(p.PrdID);
          }
        });

        // 2. Por cada productor, actualizar o poblar su matriz de calibres y días
        Object.keys(calibersByProducer || {}).forEach((prdIdStr) => {
          const prdId = parseInt(prdIdStr, 10);
          const importedCalibersDict = calibersByProducer[prdId];
          if (!importedCalibersDict) return;

          const importedList = Object.values(importedCalibersDict);

          if (!this.formAssignment.ProducerCalibersMatrix[prdId]) {
            this.$set(this.formAssignment.ProducerCalibersMatrix, prdId, importedList);
          } else {
            const existingList = this.formAssignment.ProducerCalibersMatrix[prdId];
            importedList.forEach((impCal) => {
              const found = existingList.find((c) => c.CtgID === impCal.CtgID);
              if (found) {
                if (!found.daysPrice) this.$set(found, "daysPrice", {});
                Object.keys(impCal.daysPrice || {}).forEach((dKey) => {
                  this.$set(found.daysPrice, dKey, impCal.daysPrice[dKey]);
                });
              } else {
                existingList.push(impCal);
              }
            });
          }
        });

        if (this.formAssignment.SelectedProducers.length > 0) {
          if (!this.activeProducerId || !this.formAssignment.SelectedProducers.some((p) => p.PrdID === this.activeProducerId)) {
            this.activeProducerId = this.formAssignment.SelectedProducers[0].PrdID;
          }
        }

        this.recalculateDateRange();
        this.notifyUser(`Se cargaron exitosamente los precios de ${producers.length} productores desde el Excel.`);
      } else {
        // 3. Modo Estándar
        if (!this.formAssignment.CalibersMatrix || this.formAssignment.CalibersMatrix.length === 0) {
          this.formAssignment.CalibersMatrix = standardCalibers || [];
        } else {
          (standardCalibers || []).forEach((impCal) => {
            const found = this.formAssignment.CalibersMatrix.find((c) => c.CtgID === impCal.CtgID);
            if (found) {
              if (!found.daysPrice) this.$set(found, "daysPrice", {});
              Object.keys(impCal.daysPrice || {}).forEach((dKey) => {
                this.$set(found.daysPrice, dKey, impCal.daysPrice[dKey]);
              });
            } else {
              this.formAssignment.CalibersMatrix.push(impCal);
            }
          });
        }

        this.recalculateDateRange();
        this.notifyUser(`Se cargaron exitosamente los precios de ${(standardCalibers || []).length} calibres desde el Excel.`);
      }
    },
  },
};
</script>

<style scoped>
/* PALETA GENERAL Y CONTENEDOR */
.bg-app {
  background-color: #f8fafc;
  min-height: 100vh;
}

.text-slate-500 {
  color: #64748b;
}
.text-slate-700 {
  color: #334155;
}
.text-slate-800 {
  color: #1e293b;
}
.text-slate-900 {
  color: #0f172a;
}
.bg-slate-50 {
  background-color: #f8fafc !important;
}
.bg-slate-100 {
  background-color: #f1f5f9 !important;
}

.border-soft {
  border: 1px solid #e2e8f0 !important;
}
.border-bottom {
  border-bottom: 1px solid #e2e8f0 !important;
}
.border-dashed {
  border: 2px dashed #cbd5e1 !important;
}

.header-card {
  background-color: #ffffff;
}

.icon-badge {
  background-color: #eff6ff;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-tag {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg-blue-subtle {
  background-color: #eff6ff;
}
.bg-emerald-subtle {
  background-color: #ecfdf5;
}
.bg-indigo-subtle {
  background-color: #eef2ff;
}

/* MODAL STYLES */
.dialog-modal-card {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

.modal-toolbar {
  border-bottom: 2px solid #2563eb;
}

.header-icon-circle {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-subtitle {
  font-size: 0.72rem;
  color: #bfdbfe;
  font-weight: 500;
}

.line-height-tight {
  line-height: 1.25;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.close-btn-light:hover {
  background-color: #f1f5f9;
}

.section-card {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02) !important;
}

/* DIALOG COPIAR PRECIOS ESTILOS */
.copy-dialog-card {
  box-shadow: 0 20px 30px -10px rgba(0, 0, 0, 0.15) !important;
}

.copy-icon-box {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background-color: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-badge {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.72rem;
  font-weight: 700;
}

.step-badge-blue {
  background-color: #dbeafe;
  color: #1e40af;
}

.step-badge-green {
  background-color: #dcfce7;
  color: #166534;
}

.step-badge-purple {
  background-color: #f3e8ff;
  color: #6b21a8;
}

.border-blue-subtle {
  border: 1px solid #bfdbfe !important;
}

.text-blue-800 {
  color: #1e40af !important;
}

.option-check-card {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  cursor: pointer;
}

.option-check-card.card-active {
  background-color: #eff6ff;
  border-color: #93c5fd;
}

/* RESUMEN INFERIOR KPI CARD */
.summary-kpi-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.kpi-icon-wrap {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background-color: #ecfdf5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.summary-kpi-title {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.5px;
}

.summary-kpi-subtitle {
  font-size: 0.72rem;
  color: #94a3b8;
  font-weight: 500;
}

.summary-kpi-value {
  font-size: 1.35rem;
  font-weight: 800;
  color: #0f766e;
  line-height: 1.2;
}

.summary-kpi-unit {
  font-size: 0.7rem;
  font-weight: 600;
  color: #64748b;
}

/* PILL BUTTONS (ACCIONES RÁPIDAS) */
.action-pill {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 9999px;
  border: 1px solid transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: all 0.15s ease-in-out;
}

.pill-blue {
  background-color: #f0f9ff;
  border-color: #bae6fd;
  color: #0369a1;
}
.pill-blue:hover {
  background-color: #e0f2fe;
}

.pill-indigo {
  background-color: #eef2ff;
  border-color: #c7d2fe;
  color: #3730a3;
}
.pill-indigo:hover {
  background-color: #e0e7ff;
}

.pill-purple {
  background-color: #f8fafc;
  border-color: #e2e8f0;
  color: #475569;
}
.pill-purple:hover {
  background-color: #f1f5f9;
  color: #1e293b;
}

.pill-red {
  background-color: #fff1f2;
  border-color: #fecdd3;
  color: #be123c;
}
.pill-red:hover {
  background-color: #ffe4e6;
}

/* TABLA MATRICIAL */
.custom-matrix-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
}

.custom-matrix-table th,
.custom-matrix-table td {
  border: 1px solid #e2e8f0;
  padding: 6px 8px;
}

.dark-header {
  background-color: #1e3a5f !important;
  color: #ffffff !important;
}

.dark-header th {
  color: #ffffff !important;
  font-weight: 700;
  padding: 8px 6px;
  border-bottom: 2px solid #2563eb !important;
}

.day-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #ffffff;
}

.day-date {
  font-size: 0.72rem;
  color: #93c5fd;
  font-weight: 500;
}

.tr-price {
  background-color: #ffffff;
  transition: background-color 0.15s ease;
}

.tr-price:hover {
  background-color: #f8fafc;
}

.cal-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #2563eb;
}

.calibre-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
}

.calibre-group {
  font-size: 0.72rem;
  color: #64748b;
}

.input-matrix {
  width: 100%;
  max-width: 90px;
  padding: 5px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  text-align: right;
  font-weight: 700;
  font-size: 0.85rem;
  background-color: #ffffff;
  color: #0f172a;
  transition: all 0.15s ease;
}

.input-matrix:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.input-matrix:disabled,
.input-matrix.input-view-only {
  background-color: #f1f5f9 !important;
  border-color: #cbd5e1 !important;
  color: #1e293b !important;
  cursor: default !important;
}

.price-input {
  color: #0f172a;
}

.td-actions {
  background-color: #ffffff;
  vertical-align: middle;
}

.btn-action-copy {
  background-color: #eef2ff !important;
  border-radius: 6px !important;
}

.btn-action-delete {
  background-color: #fef2f2 !important;
  border-radius: 6px !important;
}

/* ========================================================================= */
/* ESTILOS: SELECCIÓN Y NAVEGACIÓN DE PRODUCTORES CON PRECIO ESPECIAL        */
/* ========================================================================= */
.bg-purple-subtle {
  background-color: #f3e8ff;
}

.text-purple-700 {
  color: #7e22ce !important;
}

.text-purple-800 {
  color: #6b21a8 !important;
}

.producer-grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 8px;
  max-height: 220px;
  overflow-y: auto;
  padding: 2px;
}

.producer-selection-card {
  padding: 8px 12px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.producer-selection-card:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.producer-selection-card.card-selected {
  background-color: #faf5ff;
  border-color: #c084fc;
}

.producer-info-wrap {
  overflow: hidden;
  min-width: 0;
}

.prd-name {
  font-size: 0.82rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.prd-meta {
  font-size: 0.72rem;
  color: #64748b;
  margin-top: 2px;
}

/* ========================================================================= */
/* ESTILOS: PESTAÑAS HORIZONTALES Y BANNER DE PRODUCTORES CON PRECIO ESPECIAL */
/* ========================================================================= */
.producer-tabs-wrapper {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.producer-tabs-header {
  background-color: #f1f5f9 !important;
  border: 1px solid #e2e8f0;
}

.producer-tabs-scroll {
  scrollbar-width: thin;
  padding-bottom: 2px;
}

.producer-tabs-scroll::-webkit-scrollbar {
  height: 4px;
}

.producer-tabs-scroll::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}

.tabs-label-badge {
  font-size: 0.7rem;
  font-weight: 700;
  color: #475569;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  padding: 5px 8px;
  background-color: #e2e8f0;
  border-radius: 6px;
  white-space: nowrap;
}

.producer-tab-card {
  display: inline-flex;
  align-items: center;
  padding: 6px 10px;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  max-width: 230px;
  min-width: 150px;
  flex-shrink: 0;
  user-select: none;
}

.producer-tab-card:hover {
  background-color: #f8fafc;
  border-color: #cbd5e1;
}

.producer-tab-card.tab-card-active {
  background-color: #ffffff !important;
  border-color: #2563eb !important;
  box-shadow: 0 2px 4px rgba(37, 99, 235, 0.12);
  border-left: 3px solid #2563eb;
}

.tab-card-avatar {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  background-color: #f1f5f9;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.68rem;
  font-weight: 700;
  margin-right: 8px;
  flex-shrink: 0;
}

.tab-card-avatar.avatar-active {
  background-color: #eff6ff;
  color: #2563eb;
}

.tab-card-info {
  overflow: hidden;
  min-width: 0;
  flex: 1;
}

.tab-card-name {
  font-size: 0.78rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.tab-card-code {
  font-size: 0.68rem;
  color: #64748b;
  font-weight: 500;
  margin-top: 1px;
}

.btn-replicate {
  border-color: #bfdbfe !important;
  background-color: #ffffff !important;
  font-size: 0.75rem !important;
}

.producer-active-banner {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-top: none;
}

.active-badge-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background-color: #eff6ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
</style>
